import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Раздел экрана: подпись и то, что под ней.
 *
 * Весь вертикальный ритм живёт ЗДЕСЬ, и это главное. До него ритм собирался
 * из трёх мест сразу — поля секции VKUI, поля коробки `Div` и поля списка, —
 * и на каждом экране складывался по-своему: над одной подписью выходило 16, а
 * над соседней 41. Чинить это приходилось поштучно, пока владелец не сказал,
 * что чинится не то.
 *
 * Правила, которые он держит:
 * — подпись отбита от предыдущего блока шестнадцатью, от своего содержимого —
 *   десятью (в холстах 16 и 9);
 * — списки внутри раздела своих ВЕРТИКАЛЬНЫХ полей не добавляют: горизонталь
 *   у них остаётся, а высоту считает раздел;
 * — два раздела подряд без подписей разделяются теми же шестнадцатью.
 *
 * Подпись — обычный `SectionTitle` ПРЯМЫМ потомком, без обёрток: поле по
 * бокам ему даёт раздел.
 */
export function Section({ children }: { children: ReactNode }) {
  return <section className={styles.section}>{children}</section>;
}
